// import React from "react";

// const WhyDiksha = () => {
// return(
// <div className="container">
//     <div className="container">
//     <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
//             <h6 class="section-title bg-white text-center text-primary px-3">Why Diksha?</h6>
//         </div>
//         <div className="row g-4 my-3">
//         <div
//             className="col-lg-3 col-sm-6"
//             style={{
//             visibility: "visible",
//             animationDelay: "0.1s",
//             animationName: "fadeInUp",
//             animationFillMode: "both",
//             animationDuration: "1s",
//             }}
//         >
//             <div className="service-item text-center pt-3">
//             <div className="p-4">
//                 <i className="fa fa-3x fa-graduation-cap text-primary mb-4"></i>
//                 <h5 className="mb-3">Experienced Trainers</h5>
//                 <p>
//                 Learn from industry veterans who bring real-world insights into the
//                 classroom.
//                 </p>
//             </div>
//             </div>
//         </div>
//         <div
//             className="col-lg-3 col-sm-6"
//             style={{
//             visibility: "visible",
//             animationDelay: "0.3s",
//             animationName: "fadeInUp",
//             animationFillMode: "both",
//             animationDuration: "1s",
//             }}
//         >
//             <div className="service-item text-center pt-3">
//             <div className="p-4">
//                 <i className="fa fa-3x fa-globe text-primary mb-4"></i>
//                 <h5 className="mb-3">End-to-End Support</h5>
//                 <p>
//                 From foundational learning to placement, we guide you every step of the way.
//                 </p>
//             </div>
//             </div>
//         </div>
//         <div
//             className="col-lg-3 col-sm-6"
//             style={{
//             visibility: "visible",
//             animationDelay: "0.5s",
//             animationName: "fadeInUp",
//             animationFillMode: "both",
//             animationDuration: "1s",
//             }}
//         >
//             <div className="service-item text-center pt-3">
//             <div className="p-4">
//                 <i className="fa fa-3x fa-home text-primary mb-4"></i>
//                 <h5 className="mb-3">Flexible Programs</h5>
//                 <p>
//                 Whether you are a student, working professional, or career switcher, we have programs to suit your needs.
//                 </p>
//             </div>
//             </div>
//         </div>
//         <div
//             className="col-lg-3 col-sm-6"
//             style={{
//             visibility: "visible",
//             animationDelay: "0.7s",
//             animationName: "fadeInUp",
//             animationFillMode: "both",
//             animationDuration: "1s",
//             }}
//         >
//             <div className="service-item text-center pt-3">
//             <div className="p-4">
//                 <i className="fa fa-3x fa-list text-primary mb-4"></i>
//                 <h5 className="mb-3">Industry-Aligned Curriculum</h5>
//                 <p>Stay ahead with programs designed in collaboration with IT leaders and experts.</p>
//             </div>
//             </div>
//             </div>
//             <div
//             className="col-lg-3 col-sm-6"
//             style={{
//             visibility: "visible",
//             animationDelay: "0.7s",
//             animationName: "fadeInUp",
//             animationFillMode: "both",
//             animationDuration: "1s",
//             }}
//         >
//             <div className="service-item text-center pt-3">
//             <div className="p-4">
//                 <i className="fa fa-3x fa-building text-primary mb-4"></i>
//                 <h5 className="mb-3">State-of-the-Art Infrastructure</h5>
//                 <p>
//                 Fully equipped labs and a conducive learning environment.
//                 </p>
//             </div>
//             </div>
//         </div>
//         </div>
//     </div>
// </div>
// );
// };

// export default WhyDiksha;



import React from "react";

const WhyDiksha = () => {
  const features = [
    {
      icon: "fa-graduation-cap",
      title: "Experienced Trainers",
      description: "Learn from industry veterans who bring real-world insights into the classroom.",
      delay: "0.1s",
    },
    {
      icon: "fa-globe",
      title: "End-to-End Support",
      description: "From foundational learning to placement, we guide you every step of the way.",
      delay: "0.3s",
    },
    {
      icon: "fa-home",
      title: "Flexible Programs",
      description: "Tailored programs for students, professionals, and career switchers.",
      delay: "0.5s",
    },
    {
      icon: "fa-list",
      title: "Industry-Aligned Curriculum",
      description: "Stay ahead with programs designed in collaboration with IT leaders and experts.",
      delay: "0.7s",
    },
    // {
    //   icon: "fa-building",
    //   title: "State-of-the-Art Infrastructure",
    //   description: "Fully equipped labs and a conducive learning environment.",
    //   delay: "0.9s",
    // },
    // {
    //   icon: "fa-briefcase",
    //   title: "Placement Assistance",
    //   description: "Dedicated placement support to help you achieve your dream job.",
    //   delay: "1.1s",
    // },
    {
        icon: "fa-building",
        title: "State-of-the-Art Infrastructure",
        description: "Fully equipped labs and a conducive learning environment for success.",
        delay: "0.9s",
      },
      {
        icon: "fa-briefcase",
        title: "Placement Assistance",
        description: "Dedicated placement support to help you achieve your dream job opportunities.",
        delay: "1.1s",
      },
      
  ];

  return (
    <div className="container my-5">
      <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
        <h6 className="section-title bg-white text-center text-primary px-3">
          Why Diksha?
        </h6>
        <h2 className="mt-3">What Sets Us Apart</h2>
        <p className="text-muted">
          At Diksha IT Training, we are committed to providing world-class education to help you excel in the IT industry.
        </p>
      </div>
      <div className="row g-4 my-5">
        {features.map((feature, index) => (
          <div
            key={index}
            className="col-lg-4 col-md-6"
            style={{
              visibility: "visible",
              animationDelay: feature.delay,
              animationName: "fadeInUp",
              animationFillMode: "both",
              animationDuration: "1s",
            }}
          >
            <div className="service-item text-center p-4 border shadow-sm rounded">
              <div className="icon mb-3">
                <i className={`fa fa-3x ${feature.icon} text-primary`}></i>
              </div>
              <h5 className="mb-3">{feature.title}</h5>
              <p className="text-muted">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-5">
        <a href="/contact" className="btn btn-primary px-4 py-2">
          Get in Touch
        </a>
      </div>
    </div>
  );
};

export default WhyDiksha;
